export default __webpack_public_path__ + "static/media/pangong2.709dfff3.jpg";